import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';
import { isLightMode } from 'pages/Landings/utils';

export default makeStyles({ name: 'Card' })((theme) => {
    return {
        root: {
            display: 'flex',
            padding: '64px 40px 40px 40px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 32,
            flex: '1 0 0',
            borderRadius: 24,
            background: isLightMode(theme) ? '#fff' : 'rgba(255, 255, 255, 0.05)',
            border: '2px solid transparent',
            transition: 'all 0.2s',
            textDecoration: 'none',
            position: 'relative',
            zIndex: 1,
            [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
                padding: '40px 16px'
            },
            // Hack to avoid slow render of huge shadow
            '&:before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                background: 'transparent',
                boxShadow: isLightMode(theme) ? '0 0 96px 0 #ffd1c4' : '0 0 96px 0 #A44025',
                zIndex: -1,
                transition: 'all 0.2s',
                opacity: 0,
                borderRadius: 'inherit',
                backdropFilter: 'blur(40px)'
            },
            '@media (hover: hover)': {
                '&:hover': {
                    borderColor: isLightMode(theme) ? '#fbc5b2' : '#FF8B61',
                    background: isLightMode(theme) ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 0.03)',
                    '&:before': {
                        opacity: 1
                    }
                }
            }
        },
        icon: {
            lineHeight: 0,
            width: 40,
            height: 40,
            '& > svg': {
                width: '100%',
                height: '100%'
            }
        },
        hint: {
            color: isLightMode(theme) ? '#232323' : '#fff',
            fontSize: 18,
            fontWeight: 400,
            lineHeight: '160%'
        }
    };
});
